import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/layout/Sidebar'
import { TopBar } from '@/components/layout/TopBar'
import { ToastProvider } from '@/providers/ToastProvider'
import { useRealtime } from '@/hooks/useRealtime'

/**
 * App shell, as cgt-frontend (z8nrz7fv5m): the light queue sidebar, then the
 * top bar over a scrolling main column. Pages own their padding (`<Page>`);
 * ticket detail is full-bleed.
 */
export function Layout() {
  return (
    <ToastProvider>
      <Shell />
    </ToastProvider>
  )
}

function Shell() {
  useRealtime()
  return (
    <div className="flex h-full overflow-hidden bg-background">
      <Sidebar />
      <div className="flex min-w-0 grow flex-col">
        <TopBar />
        <main className="flex min-h-0 grow flex-col overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
